// extracted by mini-css-extract-plugin
export default {"default_input_style":"Inpnut_default_input_style__3va7o"};